import { render, staticRenderFns } from "./AdminProjectView.vue?vue&type=template&id=be736a38"
import script from "./AdminProjectView.vue?vue&type=script&lang=js"
export * from "./AdminProjectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports